import { Button, Tooltip } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { incrementVersion } from '../../../actions/version';
import {
	blue_pilu,
	emailDevFer,
	GLOSARY_LINK,
	justCentered,
	LOGO_P_NO_BG,
	LOGO_P_WHITE_NO_BG,
	LOGO_PILU_LINK,
	LOGO_PILU_WHITE_LINK,
	SARO_BG,
	whichPath,
	white_pilu,
} from '../../../helpers/utils';
import { Icon } from '../../utils/UtilsComponent';
import { UserMenu } from './UserMenu';
import { cleanSearcher } from '../../../actions/searcher';
import { NewVersionFeaturesDialog } from '../../dialogs/NewVersionFeaturesDialog';
import { EMAILS_ALLOWED_FOR_TICKETS } from '../../utils/lists';

const whichPage = () => {
	const href = document.location.href;
	if (href.includes('usuario')) {
		return 'users';
	} else if (href.includes('test') || href.includes('pruebas')) {
		return 'tests';
	} else if (href.includes('client')) {
		return 'clients';
	} else if (href.includes('provider')) {
		return 'providers';
	} else if (href.includes('prospeccion')) {
		return 'prospects';
	} else if (href.includes('ordenes')) {
		return 'orders';
	} else if (href.includes('cotizaciones')) {
		return 'quotation-engine';
	} else if (href.includes('area')) {
		return 'areas';
	} else if (href.includes('resumen-de-resultados')) {
		return 'summary-results';
	} else if (href.includes('resumen-de-rechazos')) {
		return 'incident-summary-results';
	} else if (href.includes('dashboard-mobile')) {
		return 'dashboard-mobile';
	} else if (href.includes('maquila-externa')) {
		return 'external-tolling';
	} else if (href.includes('plan-de-produccion')) {
		return 'production-plan';
	}
	return 'dashboard';
};

// Summary incident results staff
const STAFF_SUMMARY_INCIDENTS = [
	'doriaramos@piluniformes.com.mx',
	'almacen@piluniformes.com.mx',
	'almacen@sarouniformes.com.mx',
];

// Summary results staff
const STAFF_SUMMARY_RESULTS = [
	'doriaramos@piluniformes.com.mx',
	'almacen@piluniformes.com.mx',
	'almacen@sarouniformes.com.mx',
	'lauramejia@piluniformes.com.mx',
	'armandotrujillo@piluniformes.com.mx',
	'fabiolaluna@piluniformes.com.mx',
	'ventascelaya@piluniformes.com.mx',
	'ivoenn@sarouniformes.com.mx',
	'alejandrorivera@piluniformes.com.mx',
];

// ICONS FOR SIDEBAR: https://icons.getbootstrap.com/

// Sidebar component
export const SideBar = () => {
	// Navigation
	const navigate = useNavigate();
	// Dispatch
	const dispatch = useDispatch();

	// States
	const [navActive, setNavActive] = useState(whichPage(dispatch));
	const { user } = useSelector((state) => state);
	// Selector
	const { sidebar = true, ui = null } = useSelector((state) => state);

	// Change current active link
	const handleActiveLink = (id) => {
		setNavActive(id);
	};

	// Dialog version features
	const [dialogOpen, setDialogOpen] = useState(false);

	const handleOpenDialog = () => {
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setDialogOpen(false);
	};

	// Sidebar item component
	const SideBarItem = ({ id, path, title, icon, navigate }) => (
		<li
			className='nav-item'
			key={id}
			onClick={() => {
				if (id === 'glosary') {
					window.open(GLOSARY_LINK);
				} else {
					// Update local storage
					localStorage.setItem('currentPathPilu', path);
					localStorage.setItem('lastPathPilu', path);

					// Check if I have to do hard reload or not
					// (Just for orders)
					if (id === 'orders') {
						localStorage.setItem('lastTablePage', '1');
						localStorage.setItem('searchConfigPilu', 'null');
						document.location.reload();
					} else {
						// Set path
						navigate(path);
					}
					// Clean searcher (Redux)
					dispatch(cleanSearcher());
					// Set active link
					handleActiveLink(id);
				}
			}}
		>
			<Tooltip title={sidebar ? '' : title} placement='right-end'>
				<div
					style={{
						cursor: 'pointer',
						width: sidebar ? '100%' : '35px',
						color: ui?.theme === 'light' ? 'none' : white_pilu,
					}}
					className={`nav-link ${id === navActive && 'active'}`}
				>
					<Icon
						name={icon}
						sidebar={sidebar}
						color={ui?.theme === 'light' ? null : white_pilu}
					/>
					{sidebar ? title : ''}
				</div>
			</Tooltip>
		</li>
	);

	return (
		<>
			<NewVersionFeaturesDialog
				open={dialogOpen}
				handleClose={handleCloseDialog}
			/>
			<div
				className='d-flex flex-column flex-shrink-0 p-3'
				style={{
					backgroundColor: ui?.theme === 'light' ? null : blue_pilu,
					width: sidebar ? '250px' : '60px',
					minHeight: '100vh',
				}}
			>
				{/* SIDEBAR TITLE */}
				<div className='d-flex 1align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							...justCentered,
						}}
					>
						{/* Img Logo */}
						{sidebar ? (
							<>
								{/* Logo PILU */}
								<img
									style={{
										m: 1,
										width: '80%',
									}}
									src={ui?.theme !== 'light' ? LOGO_PILU_WHITE_LINK : LOGO_PILU_LINK}
									alt='logo-lg'
								/>
								{/* Logo SARO */}
								{ui?.theme === 'light' && (
									<img
										style={{
											margin: '20px 0 0 -15px',
											width: '85%',
										}}
										src={SARO_BG}
										alt='avatar'
									/>
								)}
							</>
						) : (
							<>
								{/* Logo PILU */}
								<img
									style={{
										m: 1,
										width:
											ui?.theme === 'light'
												? '100%'
												: '75%',
									}}
									src={ui?.theme === 'light' ? LOGO_P_NO_BG : LOGO_P_WHITE_NO_BG}
									alt='logo-sm'
								/>
							</>
						)}
					</div>
				</div>
				{/* SEPARATOR */}
				<hr
					style={{
						color: ui?.theme === 'light' ? blue_pilu : white_pilu,
					}}
				/>
				{/* MENU LIST */}
				<ul className='nav nav-pills flex-column '>
					{/* Pruebas */}
					{user?.email === emailDevFer && (
						<SideBarItem
							id='tests'
							path='/dashboard/pruebas'
							title='Pruebas'
							icon='code-slash'
							navigate={navigate}
						/>
					)}

					{/* Dashboard */}
					{[2, 5].includes(user?.user_type?.id) && (
						<>
							<SideBarItem
								id='dashboard'
								path='/'
								title='Dashboard'
								icon='speedometer2'
								navigate={navigate}
							/>
							<SideBarItem
								id='dashboard-mobile'
								path='/dashboard-mobile'
								title='Dashboard Mobile'
								icon='car-front'
								navigate={navigate}
							/>
							<SideBarItem
								id='prospects'
								path='/prospecciones'
								title='Prospecciones'
								icon='card-checklist'
								navigate={navigate}
							/>
						</>
					)}

					{/* Orders */}
					<SideBarItem
						id='orders'
						path='/dashboard/ordenes'
						title='Pedidos'
						icon='box-seam'
						navigate={navigate}
					/>

					{/* External tolling */}
					{/* TODO: to be continued (?) */}
					{/* <SideBarItem
						id='external-tolling'
						path='/dashboard/solicitudes-de-maquila-externa'
						title='Maquila externa'
						icon='boxes'
						navigate={navigate}
					/> */}

					{/* Production plan */}
					<SideBarItem
						id='production-plan'
						path='/dashboard/plan-de-produccion'
						title='Plan de producción'
						icon='calendar3'
						navigate={navigate}
					/>

					{/* Quotation engine */}
					{/* For admins, managers and Mesa de control */}
					{([1, 2, 5].includes(user?.user_type?.id) ||
						user?.area?.name === 'Mesa de Control') && (
						<SideBarItem
							id='quotation-engine'
							path='/dashboard/cotizaciones'
							title='Cotizaciones'
							icon='cash-coin'
							navigate={navigate}
						/>
					)}

					{/* Superadmin, admin or area manager view */}
					{(STAFF_SUMMARY_RESULTS.includes(user?.email) ||
						[1, 2, 3].includes(user?.user_type?.id)) && (
						<>
							{/* Fabric Summary Results */}
							<SideBarItem
								id='summary-results'
								path='/dashboard/resumen-de-resultados'
								title='Resumen'
								icon='file-earmark-ruled'
								navigate={navigate}
							/>
						</>
					)}

					{/* Superadmin, admin, area manager, consultant */}
					{(STAFF_SUMMARY_INCIDENTS.includes(user?.email) ||
						user?.area?.id === 1 ||
						[1, 2].includes(user?.user_type?.id)) && (
						<>
							{/* Incidents Summary Results */}
							<SideBarItem
								id='incident-summary-results'
								path='/dashboard/resumen-de-rechazos'
								title='Rechazos'
								icon='exclamation-triangle'
								navigate={navigate}
							/>
						</>
					)}

					{/* Glosary */}
					<SideBarItem
						id='glosary'
						path='/dashboard/glosario'
						title='Glosario'
						icon='file-earmark-text'
						navigate={navigate}
					/>

					{/* Superadmin or admin view */}
					{([1, 2].includes(user?.user_type?.id) ||
						user?.last_name?.includes('Brentón') ||
						user?.email ===
							'gerenciaproduccion@piluniformes.com.mx') && (
						<>
							{/* Users */}
							<SideBarItem
								id='users'
								path='/dashboard/usuarios'
								title='Usuarios'
								icon='people'
								navigate={navigate}
							/>

							{/* Areas */}
							<SideBarItem
								id='areas'
								path='/dashboard/areas'
								title='Áreas'
								icon='view-list'
								navigate={navigate}
							/>
						</>
					)}

					{/* Clients */}
					<SideBarItem
						id='clients'
						path='/dashboard/clientes'
						title='Clientes'
						icon='person-video2'
						navigate={navigate}
					/>

					{/* Providers */}
					<SideBarItem
						id='providers'
						path='/dashboard/proveedores'
						title='Proveedores'
						icon='basket'
						navigate={navigate}
					/>

					{/* Tickets module for admins */}
					{user?.user_type?.id == 2 && (
						<SideBarItem
							id='tickets'
							path='/dashboard/tickets'
							title='Tickets'
							icon='receipt'
							navigate={navigate}
						/>
					)}
				</ul>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						margin: '15px 0 0 0',
					}}
				>
					{user.email === 'flopezramirez@hotmail.com' && sidebar && (
						<Button
							variant='text'
							style={{
								color:
									ui?.theme === 'light'
										? blue_pilu
										: white_pilu,
							}}
							onClick={handleOpenDialog}
						>
							Actualizar versión
						</Button>
					)}
					<hr
						style={{
							color:
								ui?.theme === 'light' ? blue_pilu : white_pilu,
						}}
					/>
					{sidebar && <UserMenu />}
				</div>
			</div>
		</>
	);
};
